<div #container class="interactive-logo">
  <img
    #fallback
    class="interactive-logo__fallback"
    src="/main_logo.svg"
    alt="Sitco">
</div>
